const defaultFields = {
  client: {
    name: '',
    phone: '',
    company: '',
    country_iso: 'KW',
  },
  package: {
    id: 4,
  },
  addons: [],
  discount: {
    enabled: 0,
    value: 0,
    type: 1,
  },
  manager_id: '',
  note: '',
}
export default {
  namespaced: true,
  state: {
    form: defaultFields,
  },
  getters: {
    form: (state: any) => state.form,
    addons: (state: any) => state.form.addons,
    package: (state: any) => state.form.package,
  },
  mutations: {
    SET_FORM(state: any, payload: any) {
      state.form = payload
    },
    SET_DEFAULT_FORM(state: any) {
      state.form = { ...defaultFields }
      state.form.client = { ...defaultFields.client }
      state.form.addons = []
    },
    CHANGE_ADDONS_CURRENCY(state: any, payload: any) {
      let { addons } = state.form
      if (addons.length > 0) {
        // eslint-disable-next-line no-param-reassign
        addons = addons.map((addon: any) => ({ ...addon, currency: payload.currency }))
        state.form.addons = addons
      }
    },
  },
  actions: {
    UPDATE_FORM(context: any, form: any) {
      const quotation = {
        ...context.state.form,
        ...form,
      }
      context.commit('SET_FORM', quotation)
    },
    UPDATE_ADDONS_CURRENCY(context: any, payload: any) {
      context.commit('CHANGE_ADDONS_CURRENCY', { currency: payload.currency })
    },
  },
}
